import React, { useState, useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import FeedbackServices from '../services/FeedbackServices';
import Modal from 'react-modal';
import StarRating from './Rating/StarRating'; 
import { format } from 'date-fns';

Modal.setAppElement('#root');

function VendorWiseRating() {
  const [searchParams] = useSearchParams();
  const vendorId = searchParams.get('vendorId');
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [vendorData, setVendorData] = useState(null);
  const [reviews, setReviews] = useState([]);
  const [pagination, setPagination] = useState({});
  const [isModalOpen, setIsModalOpen] = useState(false);

  function formatDateTime(isoString) {
    const date = new Date(isoString);
    return date.toLocaleDateString();
  }


  const fetchVendorReviews = async () => {
    try {
      setLoading(true);
      const response = await FeedbackServices.perVendorWiseRating(vendorId);

      console.log("API Response:", JSON.stringify(response.data, null, 2));
      
      setVendorData(response.data.vendorInfo);
      setReviews(response.data.reviews || []);
      setPagination(response.data.pagination || {});
      setLoading(false);
    } catch (error) {
      console.error('Error fetching vendor reviews:', error);
      setError(error.message);
      setLoading(false);
    }
  };

  useEffect(() => {
    if (vendorId) {
      fetchVendorReviews();
    }
  }, [vendorId]);

  return (
    <div className="right_col" role="main">
        <div className="d-md-flex  align-items-center justify-content-between my-4 page-header-breadcrumb">

          <div className="my-auto">
            <nav>
              <ol className="breadcrumb mb-0">
                <li className="breadcrumb-item">
                  <a href="javascript:void(0);">Home</a>
                </li>
                <li className="breadcrumb-item active" aria-current="page">
                Vendor Wise Feedback
                </li>
              </ol>
            </nav>
          </div>
          <div className="d-flex my-xl-auto gap-2 right-content align-items-center">
          </div>
        </div>


        <div className="container-box px-0">
          <div className="container-box-inner table-reponsive-tabe">
            <table id="example" className="table table-striped" style={{ width: '100%' }}>
              <thead>
                <tr>
                  <th>#</th>
                  <th>SERVICE NAME</th>
                  <th>User NAME</th>
                  <th>User MOBILE</th>
                  <th>RATING</th>
                  <th>DATE</th>
                </tr>
              </thead>
              {reviews.length > 0 ? (
                <tbody>
                  {reviews.map((review, index) => (
                    <tr key={index}>
                      <td>{index + 1}</td>
                      <td>{review?.service?.title}</td>
                      <td>{review?.user?.firstName}</td>
                      <td>{review?.user?.mobileNo}</td>
                      <td><StarRating rating={review?.rating} /></td>
                      <td className="payment">{formatDateTime(review?.createdAt)}</td>
                    </tr>
                  ))}
                </tbody>
              ) : (
                <tbody>
                  <tr><td colSpan="9">No Feedback Found</td></tr>
                </tbody>
              )}
            </table>
          </div>
         
          
        </div>
       
      </div>
   
  );
}
export default VendorWiseRating;